import React, { Component } from 'react';

class Footer extends Component {
  render() {

    return (
      <footer>

     <div className="row">
        <div className="twelve columns">

           <ul className="copyright">
              <li>Website created by Max Shein in Spanish C, Martin</li>
              <li><a title="Citations" href={process.env.PUBLIC_URL + "/citations.html"}>Citations</a></li>
           </ul>

        </div>
        <div id="go-top"><a className="smoothscroll" title="Back to Top" href="#home"><i className="icon-up-open"></i></a></div>
     </div>
  </footer>
    );
  }
}

export default Footer;
